import * as d3 from 'd3';

import { useEffect, useState } from 'react';

/**
 * Sets up a common d3 force-layout
 *
 * @param data
 * @param forces
 * @param dimensions
 * @returns {{simulation: unknown, tick: number}}
 */
export const useForceSimulation = ({ data, forces, dimensions }) => {
  const [tick, setTick] = useState(Date.now());
  const [simulation, setSimulation] = useState(null);

  useEffect(() => {
    const simulation = d3
      .forceSimulation(data)
      .on('tick', () => setTick(Date.now()))
      .on('end', () => setTick(Date.now()));

    forces.forEach(f => {
      simulation.force(f.name, f.force);
    });

    setSimulation(simulation);
    return () => simulation.stop();
  }, [data, forces, dimensions]);

  return {simulation, tick};
};

/**
 * Helper hook to set up zoom functionality.
 *
 * @param svgRef
 * @param containerRef
 * @param zoomMin
 * @param zoomMax
 */
export const useZoom = ({svgRef, containerRef, zoomMin = 0.1, zoomMax = 4.0}) => {
  useEffect(() => {
    if (!svgRef || !containerRef) return;

    // set up the zoom, which is on the SVG
    d3.select(svgRef.current)
      .call(d3.zoom()
        .scaleExtent([zoomMin, zoomMax])
        .on("zoom", () => { d3.select(containerRef.current).attr("transform", d3.event.transform); })
      )
  }, [svgRef, containerRef, zoomMin, zoomMax]);
};

export const dragHook = simulation => d3.drag()
    .on("start", (d) => {
      d3.event.sourceEvent.stopPropagation();
      if (!d3.event.active) simulation.alphaTarget(0.3).restart();
      d.fx = d.x;
      d.fy = d.y;
    })
    .on("drag", (d) => {
      d.fx = d3.event.x;
      d.fy = d3.event.y;
    })
    .on("end", (d) => {
      if (!d3.event.active) simulation.alphaTarget(0);
      d.fx = null;
      d.fy = null;
    })
